import { CLASS_NAMES } from '../../utils/constants'
import GameObject from './GameObject'

export default class Destroyable extends GameObject {
  constructor(props) {
    super(props)
    this.inactive = false
  }
  overrunBy(el) {
    if(el.power > this.strength) {
      this.inactive = true
      this.level.onDestroyElement(this)
    }
  }
}

Destroyable.className = CLASS_NAMES.DESTROYABLE
